import { z } from "zod";
// A session template as a practitioner chooses between them for a session.
//
// Its own shape rather than the admin SessionTemplateSchema: a practitioner
// picks a template by name, and what it is for and who wrote it are the
// administrator's business.
export const PractitionerSessionTemplateSchema = z.object({
    id: z.guid(),
    name: z.string(),
});
// The templates that match the session's program and service type. When none
// does, every template, for the practitioner to choose from: isMatch says which.
export const PractitionerSessionTemplatesResponseSchema = z.object({
    sessionTemplates: z.array(PractitionerSessionTemplateSchema),
    isMatch: z.boolean(),
});
